const PopupNewsletterForm = function() {
    function PopupNewsletterForm() {
        this.selector = {
            popupbox: document.getElementById('pop-up-newsletter-form'),
            popupboxoverlay: document.getElementById('pop-up-newsletter-form-overlay'),
            popupboxclose: document.getElementById('pop-up-newsletter-form-close'),
            popupform: document.getElementById('pop-up-form-container'),
            popupsuccess: document.getElementById('pop-up-successfully-posted'),
            popupalert: document.getElementById('pop-up-form-alert')
        }
        this.state = {
            mouseX: null,
            mouseY: null,
            intervalId: null
        }
        this.load();
    }
    PopupNewsletterForm.prototype.load = function() {
        var _ = this;
        document.addEventListener("DOMContentLoaded", function() {
            window.addEventListener("load", async function() {
                setTimeout(function() {
                    const formValidation = _.validateform();
                    if(formValidation && formValidation === 'true') {
                        _.selector.popupbox.classList.add('active');
                        _.selector.popupform.classList.remove('active');
                        _.selector.popupsuccess.classList.add('active');
                        _.selector.popupboxoverlay.classList.add('active');
                        _.startburst();
                    }
                    const newsletterAccepted = _.getcookie('newsletteraccepted');
                    const recaptchaEnabled = window.location.pathname.includes('challenge');
                    if(newsletterAccepted === 'false' && !recaptchaEnabled) {
                        _.selector.popupbox.classList.add('active');
                        _.selector.popupform.classList.add('active');
                        _.selector.popupboxoverlay.classList.add('active');
                    }
                    const tagsValidation = _.validatetags();
                    if(tagsValidation && tagsValidation === 'newsletter') {
                        _.selector.popupalert.classList.add('active');
                        _.setcookie("newsletteraccepted", "true", 30);
                    }
                }, 1000); 
            });
        });
        if(_.selector.popupboxclose) {
            _.selector.popupboxclose.addEventListener('click', () => {
                _.selector.popupbox.classList.remove('active');
                _.selector.popupboxoverlay.classList.remove('active');
                _.selector.popupbox.querySelector('.alert').classList.remove('active');                
                _.stopburst();              
                _.selector.popupboxoverlay.innerHTML = '';
                const baseUrl = window.location.origin + window.location.pathname;
                history.replaceState({}, document.title, baseUrl);
            })
        }
        _.setcookie("newsletteraccepted", "true", 30);
    }
    PopupNewsletterForm.prototype.startburst = function() {
        var _ = this;
        _.state.intervalId = setInterval(function() {
            for (let i = 0; i < 10; i++) {
                _.fallingballs();
            }         
        },500)
    }
    PopupNewsletterForm.prototype.stopburst = function() {
        var _ = this;
        clearInterval(_.state.intervalId);
    }
    PopupNewsletterForm.prototype.validatetags = function() {
        var _ = this;
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('contact[tags]');
    }
    PopupNewsletterForm.prototype.validateform = function() {
        var _ = this;
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('customer_posted');
    }
    PopupNewsletterForm.prototype.fallingballs = function() {
        var _ = this;
        const ball = document.createElement('div');
        ball.classList.add('ball');
      
        // Randomize position within container width and height
        const randomX = Math.random() * _.selector.popupboxoverlay.offsetWidth;
        const randomY = Math.random() * _.selector.popupboxoverlay.offsetHeight;
        ball.style.left = randomX + 'px';
        ball.style.top = randomY + 'px';
      
        // Randomize size between 10px and 30px
        const randomSize = Math.random() * (30 - 10) + 10;
        ball.style.width = randomSize + 'px';
        ball.style.height = randomSize + 'px';
      
        // Randomize background color
        const randomColor = '#' + Math.floor(Math.random() * 16777215).toString(16);
        ball.style.backgroundColor = randomColor;
      
        _.selector.popupboxoverlay.appendChild(ball);
        // Remove ball from DOM after animation ends
        ball.addEventListener('animationend', function() {
            _.selector.popupboxoverlay.removeChild(ball);
        });
    }
    PopupNewsletterForm.prototype.setcookie = function(name, value, daysToExpire) {
        var expirationDate = new Date();
        expirationDate.setTime(expirationDate.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
        var expires = "expires=" + expirationDate.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }
    PopupNewsletterForm.prototype.getcookie = function(name) {
        var decodedCookie = decodeURIComponent(document.cookie);
        var cookiesArray = decodedCookie.split(';');
        for(var i = 0; i < cookiesArray.length; i++) {
            var cookie = cookiesArray[i].trim();
            if (cookie.indexOf(name + "=") == 0) {
                return cookie.substring(name.length + 1);
            }
        }
        return "false";
    }
    PopupNewsletterForm = new PopupNewsletterForm;
}
PopupNewsletterForm();